<div class="d-inline">
    <!-- <div *ngIf="showActionMenu" [ngClass]="{'design-block-item-action-photo-gallery-middle': isMiddleImageOfView,
                                            'design-block-item-action-photo-gallery': !isMiddleImageOfView}"> -->
    <div [ngClass]="{
            'photo-grid-image-item': kind === WebsiteBlockTextAndMediaType.PhotoGalleryGrid,
            'photo-carousel-image-item': kind !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid,
            'd-flex justify-content-between': kind !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid && isMiddleImageOfView
        }"
        websiteBlockImage
        [websiteMode]="Scope.websiteMode">

        <lib-image-action-menu></lib-image-action-menu>

        <ng-content select="[image]"></ng-content>
    </div>
</div>
